import ExpandableTableForOrderAuth from "../../expandableTableForOrderAuth/expandableTableForOrderAuth";
import {
  ExpandableRowContentType,
  SingleOrderClubbedData,
} from "../../expandableTableForOrderAuth/types";

/** Default copy shown above the linked sibling orders table. */
export const DEFAULT_SIBLING_ORDER_CONTENT_TEXT =
  "You changed an order for this patient's regimen. Would you like to apply these changes to other dates of service?";

/** Props for {@link RenderSiblingOrderContentBody}. */
interface RenderSiblingOrderContentBodyProps {
  /** Clubbed sibling rows for the expandable table. */
  expandableTableData: SingleOrderClubbedData[];
  /** Whether sibling orders are still loading from context. */
  siblingOrdersLoading: boolean;
  /** Error message when sibling fetch failed; null when none. */
  siblingOrdersError: string | null;
  /** Optional override for the description above the table. */
  descriptionText?: string;
  /** Called when the user toggles row checkboxes in the linked orders table. */
  onSelectedOrderIdsChange?: (orderIds: string[]) => void;
  /** The type of content to display in the expanded row. */
  expandedContentType: ExpandableRowContentType;
}

/**
 * Renders linked sibling order copy and the expandable auth table.
 *
 * @param props - Table data, expanded-row content type, loading/error state, and description override
 * @returns Sibling order confirmation body content
 */
const RenderSiblingOrderContentBody = (
  props: RenderSiblingOrderContentBodyProps,
) => {
  const {
    expandableTableData,
    siblingOrdersLoading,
    siblingOrdersError,
    descriptionText = DEFAULT_SIBLING_ORDER_CONTENT_TEXT,
    onSelectedOrderIdsChange,
    expandedContentType,
  } = props;

  return (
    <div className="render-sibling-order-content-body">
      <div className="render-sibling-order--text text-tiny font-semibold">
        {descriptionText}
      </div>
      <div className="render-sibling-order--table">
        <ExpandableTableForOrderAuth
          data={expandableTableData}
          expandedContentType={expandedContentType}
          isLoading={siblingOrdersLoading}
          error={siblingOrdersError as string | null}
          onSelectedOrderIdsChange={onSelectedOrderIdsChange}
        />
      </div>
    </div>
  );
};

export default RenderSiblingOrderContentBody;
